/* =============================================================================
   vp-pdp.js — zwei kleine Eingriffe auf der Produktseite
   26.08.2026

   Wird von snippets/custom-assets.liquid nur auf Produktvorlagen geladen.

   1. USP-Blasen paarweise in Zeilen buendeln
      Ein CSS-Raster kann nicht beides: vier Blasen in ihrer eigenen Textbreite
      UND in beiden Zeilen denselben Abstand. Die Spaltenbreite richtet sich
      immer nach dem laengsten Eintrag, die schmalere Blase laesst eine Luecke
      (gemessen 48px oben gegen 10px unten). Zwei echte Zeilen loesen das:
      jede Zeile ist ein eigener Flex-Container, die Blasen behalten ihre
      Textbreite, der Abstand ist ueberall 10px.

      Ohne JavaScript bleibt das Raster aus vp-pdp-blocks.css stehen — dann
      eben mit zwei Spaltenbreiten statt vier. Nichts bricht.

   2. "Versand beim Checkout berechnet." aus dem Preishinweis streichen
      Das Theme rendert unter dem Preis "Steuern inklusive.&nbsp;<a>Versand</a>
      beim Checkout berechnet." — beides in einem Element, der Nachsatz als
      blosser Textknoten. CSS kann einen Textknoten nicht ausblenden, und die
      Liquid-Stelle liegt in sections/main-product.liquid (507 KB, zweimal).
      Also wird ab dem Link alles entfernt und der Steuersatz behalten.

      Faellt das Skript aus, bleibt der Satz vollstaendig stehen. Das ist der
      unkritische Ausfallweg: die Aussage ist richtig, nur laenger als
      gewuenscht.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__vpPdp) return;
  window.__vpPdp = true;

  /* --- 1. Blasen paarweise buendeln ------------------------------------ */
  function buildBadgeRows(box) {
    if (!box || box.getAttribute('data-vp-rows') === 'ready') return;

    var badges = Array.prototype.filter.call(box.children, function (n) {
      return n.classList && n.classList.contains('custom-badge');
    });
    if (badges.length < 2) return;

    box.setAttribute('data-vp-rows', 'ready');
    for (var i = 0; i < badges.length; i += 2) {
      var row = document.createElement('div');
      row.className = 'vp-badge-row';
      box.insertBefore(row, badges[i]);
      row.appendChild(badges[i]);
      if (badges[i + 1]) row.appendChild(badges[i + 1]);
    }
    box.classList.add('vp-badges-rows');
  }

  /* --- 2. Versandsatz streichen ----------------------------------------
     Annahme: der Steuersatz steht VOR dem Versandlink. So rendert das Theme
     es (products.product.include_taxes, dann shipping_policy_html). Drehte
     sich die Reihenfolge einmal um, wuerde hier der falsche Teil fallen —
     deshalb wird nur zugeschnitten, wenn vor dem Link ueberhaupt Text steht. */
  function trimShippingNote(el) {
    if (!el) return;
    if (el.getAttribute('data-vp-ship') === 'trimmed') return;
    /* In der Schweiz und in Liechtenstein schreibt vp-tax-note.js diesen
       Hinweis komplett neu — dort nicht hineinfunken. */
    if (el.getAttribute('data-vp-tax')) return;
    if (document.getElementById('vp-tax-note-product')) return;

    var link = el.querySelector('a');
    if (link) {
      var davor = '';
      var n = el.firstChild;
      while (n && n !== link) {
        davor += n.textContent || '';
        n = n.nextSibling;
      }
      if (!davor.replace(/[\s ]/g, '')) return;   // vor dem Link steht nichts

      n = link;
      while (n) {
        var naechster = n.nextSibling;
        n.parentNode.removeChild(n);
        n = naechster;
      }
    }

    /* Haengende Leerzeichen und geschuetzte Leerzeichen am Ende abraeumen. */
    var last = el.lastChild;
    while (last && last.nodeType === 3 && !last.textContent.replace(/[\s ]/g, '')) {
      el.removeChild(last);
      last = el.lastChild;
    }
    if (last && last.nodeType === 3) {
      last.textContent = last.textContent.replace(/[\s ]+$/, '');
    }

    el.setAttribute('data-vp-ship', 'trimmed');
  }

  function sweep() {
    var box = document.querySelector('.custom-product-badges');
    if (box) buildBadgeRows(box);

    var notes = document.querySelectorAll('.product__shipping-policy');
    Array.prototype.forEach.call(notes, trimShippingNote);
  }

  function boot() {
    sweep();
    /* Der Preisblock wird beim Variantenwechsel neu gerendert, der
       Empfehlungsblock nachgeladen. Der Beobachter faengt beides ab. */
    if (typeof window.MutationObserver === 'function') {
      var geplant = false;
      new MutationObserver(function () {
        if (geplant) return;
        geplant = true;
        window.setTimeout(function () {
          geplant = false;
          try { sweep(); } catch (e) { /* darf die Seite nie blockieren */ }
        }, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () {
      try { sweep(); } catch (e) { /* siehe oben */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
